import {createApp, defineAsyncComponent, inject} from 'vue'
import Content from 'views/content'
import Setup from 'views/setup'
import Frontoffice from 'views/frontoffice'
import Login from 'views/login'
import Layout from 'views/layout'
import Dashboard from 'views/dasboard'
import Home from 'views/home'
import ChatReservation from 'views/chatReservation';
import DigitCode from 'components/global/inputs/DigitCode.vue'
import Password from 'components/global/inputs/Password.vue'
import Multiselect from 'components/global/inputs/Multiselect.vue'
import DateRangePicker from 'components/global/inputs/DateRangePicker.vue'
import Custom from 'components/global/inputs/Custom.vue'
import AlternativeCheckbox from 'components/global/inputs/AlternativeCheckbox.vue'
import NumberAdvanced from 'components/global/inputs/NumberAdvanced.vue'
import NumberAdvancedNoPropagate from 'components/global/inputs/NumberAdvancedNoPropagate.vue'
import MultiStepSlider from 'components/global/inputs/MultiStepSlider.vue'
import Translation from 'components/global/inputs/Translation.vue'
import WYSIWYG from "components/global/inputs/WYSIWYG.vue";
import PrimeVue from 'primevue/config';
import './assets/css/styles.scss'
import VCalendar from 'v-calendar';
import {setI18nLanguage, setupI18n} from "locale";
import router from "router";
import {i18n} from "store/global/locale";
import {createPinia} from 'pinia'
import {createInput, defaultConfig, plugin} from '@formkit/vue'
import {de, fr} from '@formkit/i18n'
import {stateAttrsPlugin,} from "./lib/formkit/stateAttrsPlugin";
import {addAsteriskPlugin} from "./lib/formkit/required-indicator";
import {autoAnimatePlugin} from "@formkit/auto-animate/vue";
import {createAutoAnimatePlugin, createAutoHeightTextareaPlugin} from '@formkit/addons'
import {globalStore} from "store/global";
import {getInitialLoad} from "services/global";
import dayjs from "utils/day";

import Commander from "views/commander";
import Backoffice from "views/backoffice";
import Reporting from "views/reporting";
import Support from "views/support";
import {createProPlugin, datepicker, mask, rating, repeater, taglist, toggle} from "@formkit/pro";
import {generateClasses} from '@formkit/themes'
import {genesisIcons} from "@formkit/icons";
import theme from './assets/formkit.theme';

const apps = [];

window.addEventListener('load', async () => {

	await setupI18n()

	// Obtain all button-counter elements
	let elements = document.getElementsByClassName('vue-app');

	// Convert HTMLCollection to array
	let arr = Array.prototype.slice.call(elements)
	if(document.getElementById("app")){
		arr.push("#app")
	}

	const pinia = createPinia();


	let userSettings;
	let userApplications;
	let favorites;
	let unreadNotifications: number;
	let connection;
	let announcement;
	let portfolioID: number | boolean = false;

	try {
		portfolioID = parseInt(sessionStorage.getItem("portfolioID"));
	} catch (e) {
		console.warn("Error while getting portfolio ID")
	}

	try {
		if (!(elements[0] as HTMLElement)?.dataset?.isLogin) {

			const initialLoadResponse = await getInitialLoad(portfolioID);
			userSettings = initialLoadResponse.data?.data?.userSettings;
			userApplications = initialLoadResponse.data?.data?.applications;
			favorites = initialLoadResponse.data?.data?.favorites;
			connection = initialLoadResponse.data?.data?.connection;
			unreadNotifications = initialLoadResponse.data?.data?.unreadNotifications;
			announcement = initialLoadResponse.data?.data?.announcement ?? false;

			// const [userSettingsResponse, userApplicationsResponse, favoritesResponse] = await Promise.all([getUserSettings(portfolioID), getUserApplications(), getAppFavorites()]);
			// userSettings = userSettingsResponse.data.data;
			// userApplications = userApplicationsResponse.data.data;
			// favorites = favoritesResponse.data.data;
		}

	} catch (e) {
		console.warn("Error while loading user settings")
	}

	// Loop through array and mount all elements
	arr.forEach((el) => {

		const app = createApp({
			setup() {
				const useGlobalStore = globalStore();
				useGlobalStore.formkit = inject(Symbol.for('FormKitConfig'));

				if (userSettings?.user) {
					setI18nLanguage(userSettings.user.language);
					useGlobalStore.formkit.locale = userSettings.user.language;

					useGlobalStore.setApplications(userApplications);
					useGlobalStore.setUser(userSettings.user);
					useGlobalStore.setHotels(userSettings.hotels);
					useGlobalStore.setCurrentHotel(userSettings.currentHotel);
					useGlobalStore.setDomainHotels(userSettings.domainHotels);
					useGlobalStore.setRegistries(userSettings.registries);
					useGlobalStore.setFavorites(favorites);
					useGlobalStore.setUnreadNotifications(unreadNotifications);
					useGlobalStore.setConnection(connection);
					useGlobalStore.setAnnouncement(announcement);

					dayjs.locale(userSettings.user.language)
				}

				const evt = new CustomEvent("VueLoaded");
				window.dispatchEvent(evt);

			}
		}).use(router).use(i18n.value).use(pinia)

		Content(app)
		Setup(app)
		Frontoffice(app)
		Backoffice(app)
		Reporting(app)
		Login(app)
		Layout(app)
		Dashboard(app)
		Home(app)
		Commander(app)
		ChatReservation(app)
		Support(app)

		app.config.performance = true;
		app.use(VCalendar)
		app.use(autoAnimatePlugin)

		// Formkit Pro
		const proPlugin = createProPlugin('fk-3f92ff064', {
			rating,
			toggle,
			datepicker,
			repeater,
			mask,
			taglist
		})

		app.use(plugin, defaultConfig({
			inputs: {
				digitCode: createInput(DigitCode, {
					props: ['digits'],
				}),
				password: createInput(Password, {
					props: ['showRequirements'],
				}),
				multiselect: createInput(Multiselect, {
				}),
				/**
				toggle: createInput(Toggle, {
				}),
				 */
				dateRangePicker: createInput(DateRangePicker, {
					props: ['quick'],
				}),
				alternativeCheckbox: createInput(AlternativeCheckbox, {
				}),
				custom: createInput(Custom, {
				}),
				numberAdvanced: createInput(NumberAdvanced, {
					props: ['min', 'max'],
				}),
				numberAdvancedNoPropagate: createInput(NumberAdvancedNoPropagate, {
					props: ['min', 'max'],
				}),
				multiStepSlider: createInput(MultiStepSlider, {
					props: ['min', 'max', 'blockStart', 'blockEnd', 'allowAdd'],
				}),
				translation: createInput(Translation, {
					props: ['allowAutoTranslate']
				}),
				wysiwyg: createInput(WYSIWYG, {
				}),
			},
			// @ts-ignore
			plugins: [
				createAutoAnimatePlugin(
					{
						/* optional AutoAnimate config */
						// default:
						duration: 250,
						easing: 'ease-in-out',
					},
					{
						/* optional animation targets object */
						// default:
						global: ['outer', 'inner'],
						form: ['form'],
						repeater: ['items'],
					}
				),
				//@ts-ignore
				stateAttrsPlugin, addAsteriskPlugin, createAutoHeightTextareaPlugin(), proPlugin],
			locales: {de, fr},
			icons: {
				...genesisIcons,
			},
			config: {
				// @ts-ignore
				classes: generateClasses(theme),
				/*
				classes: generateClasses({
					text: {
						inner: 'formkit-custom-error',
					},
					button: {
						inner: 'btn'
					}
				})
				 */
			},
			iconLoader: (iconName) => {
				return `<i class="fa-solid fa-${iconName}"></i>`
			}
		},))
		app.use(PrimeVue, {
			locale: {
				monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Tue', 'Fri', 'Sat'],
				dayNamesMin: ['S', 'M', 'T', 'W ', 'T', 'F ', 'S'],
				firstDayOfWeek: 1,
			}
		})
		// app.mount('#app')

		// Global available Components
		app.component('Tooltip', defineAsyncComponent(() => import(/* webpackChunkName: "Tooltip" */ 'components/global/Tooltip.vue')))
		app.component('Modal', defineAsyncComponent(() => import(/* webpackChunkName: "Modal" */ 'components/global/Modal.vue')))
		app.component('Confirm', defineAsyncComponent(() => import(/* webpackChunkName: "Modal" */ 'components/global/Confirm.vue')))
		app.component('Loading', defineAsyncComponent(() => import(/* webpackChunkName: "Loading" */ 'components/global/Loading.vue')))
		app.component('ResourceLink', defineAsyncComponent(() => import(/* webpackChunkName: "ResourceLink" */ 'components/global/ResourceLink.vue')))
		app.component('Dialog', defineAsyncComponent(() => import(/* webpackChunkName: "Dialog" */ 'components/global/Dialog.vue')))

		app.mount(el);
		apps.push(app);
	});
});

(async () => {
	import(/* webpackChunkName: "Sentry" */ './utils/sentry').then((sentry) => {
		sentry.initSentry(apps, router);
	});
})().catch(err => {
	console.error(err);
});

